<template>
    <header id="masthead" class="site-header new-header header-custom-admin" v-if="hiddenMenu">
        <HeaderMenu :cartItem="cartItem" @toggle-minicart="toggleMiniCart" />
        <HeaderMenuMobile :cartItem="cartItem" @toggle-minicart="toggleMiniCart" />
    </header>
    <header id="masthead" class="site-header new-header" v-else>
        <!-- <AnnouncementBar /> -->
        <div class="main_top_menu custom_menu_bar" id="custom_menu" :style="{ backgroundColor: background_announcement }">
            <div class="left_menu">
                <div class="item_left">
                    <NuxtLink class="store-location" :to="getLangUrl('/locate-us/', baseUrl, locale)">
                        <img class="icon_locate" src="@/assets/images/icon_locate.png" width="15" height="15" alt="" />
                        <span class="text-widget">Store Locator</span>
                    </NuxtLink>

                    <NuxtLink  class="cons-url" :to="getLangUrl('/consultation/', baseUrl, locale)">
                        <img class="icon_locate" src="@/assets/images/icon_calender.png" width="15" height="15" alt="" />
                        <span class="text-widget">Book Appointment</span>
                    </NuxtLink>
                    <div class="header-toplink" >
                        <NuxtLink class="cons-url ear-url" :to="getLangUrl('/ear-piercing/', baseUrl, locale)">
                            <img class="icon_locate" src="@/assets/images/icon_phonw.png" width="15" height="15" alt="" />
                            <span class="text-widget">Ear Piercing Appointment</span>
                        </NuxtLink>
                    </div>
                </div>
            </div>
            <div class="center_menu">
                <AnnouncementBar @loading-cny="loading_cny = $event"  />
            </div>
            <div class="right_menu">
                <!-- <div class="header_country">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_61369_60323)">
                        <path d="M8.2251 0.5C8.4726 0.5 8.74474 0.625357 9.05331 0.960714C9.36403 1.295 9.67795 1.82857 9.94474 2.51321C10.1955 3.15286 10.398 3.9275 10.5501 4.78571H5.9001C6.05224 3.92857 6.25474 3.15286 6.50545 2.51321C6.77224 1.82964 7.08724 1.295 7.39688 0.959643C7.70545 0.626429 7.9776 0.5 8.2251 0.5ZM6.18938 0.785C5.93224 1.17071 5.7051 1.61643 5.50688 2.12429C5.18144 2.98482 4.94591 3.87671 4.80403 4.78571H1.45367C1.91184 3.81955 2.57151 2.96264 3.38834 2.27259C4.20517 1.58253 5.16025 1.0753 6.18938 0.785ZM10.2608 0.785C11.2899 1.0753 12.245 1.58253 13.0619 2.27259C13.8787 2.96264 14.5384 3.81955 14.9965 4.78571H11.6462C11.5043 3.87671 11.2687 2.98482 10.9433 2.12429C10.7642 1.6548 10.5354 1.20582 10.2608 0.785ZM1.03903 5.85714H4.67545C4.59687 6.56878 4.55574 7.28405 4.55224 8C4.55224 8.74571 4.60367 9.45393 4.67545 10.1429H1.03903C0.831306 9.44751 0.725562 8.72571 0.725098 8C0.725098 7.25429 0.837598 6.53643 1.03903 5.85714ZM5.75546 5.85714H10.6947C10.7708 6.54071 10.8265 7.25 10.8265 8C10.8265 8.75 10.7708 9.45714 10.6947 10.1429H5.75546C5.67938 9.45714 5.62367 8.75 5.62367 8C5.62367 7.25 5.67938 6.54071 5.75546 5.85714ZM11.7737 5.85714H15.4112C15.6126 6.53643 15.7251 7.25429 15.7251 8C15.7251 8.74571 15.6126 9.46357 15.4112 10.1429H11.7737C11.8465 9.45393 11.898 8.74571 11.898 8C11.898 7.25429 11.8465 6.545 11.7737 5.85714ZM1.45581 11.2143H4.80403C4.96688 12.2064 5.20581 13.1086 5.50688 13.8779C5.70403 14.3846 5.93117 14.8282 6.18724 15.2129C5.15909 14.9222 4.20498 14.4151 3.38893 13.7255C2.57288 13.0358 1.91377 12.1796 1.45581 11.2143ZM5.90224 11.2143H10.548C10.3969 12.0714 10.1944 12.8504 9.94474 13.4889C9.67795 14.1736 9.36295 14.7061 9.05331 15.0425C8.74474 15.3768 8.4726 15.5 8.2251 15.5C7.9776 15.5 7.70545 15.3768 7.39688 15.0414C7.08617 14.7061 6.77224 14.1736 6.50545 13.4889C6.25581 12.8504 6.05331 12.0714 5.90224 11.2143ZM11.6462 11.2143H14.9944C14.5364 12.1796 13.8773 13.0358 13.0613 13.7255C12.2452 14.4151 11.2911 14.9222 10.263 15.2129C10.519 14.8271 10.7451 14.3846 10.9433 13.8779C11.2433 13.1086 11.4833 12.2064 11.6462 11.2143Z" fill="white"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_61369_60323">
                        <rect width="16" height="16" fill="white"/>
                        </clipPath>
                        </defs>
                    </svg>
                    <a href="#" @click.prevent="navigateToLocalized(localizedPathEn)" :class="['item_country', { is_active: locale === 'en' }]">EN</a>
                    <span>|</span>
                    <a href="#" @click.prevent="navigateToLocalized(localizedPathMs)" :class="['item_country', { is_active: locale === 'ms-my' }]">MS</a>
                </div> -->
                <div class="country-selector alt-nuxt-sg" >
                    <span @click="shopPopupSelectCountry()" class="alt-header-country-selector">
                        <svg class="icon_shipping" width="15" height="15" viewBox="0 0 15 15" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path d="M8.25 2.625H1.5C1.28906 2.625 1.125 2.8125 1.125 3V9.75C1.125 9.96094 1.28906 10.125 1.5 10.125H1.78125C2.17969 9.46875 2.90625 9 3.75 9C4.57031 9 5.29688 9.46875 5.69531 10.125H7.5H8.25C8.4375 10.125 8.625 9.96094 8.625 9.75V3C8.625 2.8125 8.4375 2.625 8.25 2.625ZM9 11.25H8.8125H8.25H7.5H6C6 12.4922 4.99219 13.5 3.75 13.5C2.50781 13.5 1.5 12.4922 1.5 11.25C0.65625 11.25 0 10.5938 0 9.75V3C0 2.17969 0.65625 1.5 1.5 1.5H8.25C9.07031 1.5 9.75 2.17969 9.75 3V3.75H10.7344C11.0859 3.75 11.4141 3.89062 11.6719 4.14844L13.8516 6.32812C14.1094 6.58594 14.25 6.91406 14.25 7.26562V10.125H14.4375C14.7422 10.125 15 10.3828 15 10.6875C15 11.0156 14.7422 11.25 14.4375 11.25H13.5C13.5 12.4922 12.4922 13.5 11.25 13.5C10.0078 13.5 9 12.4922 9 11.25ZM13.0547 7.125L10.875 4.94531C10.8281 4.89844 10.7812 4.875 10.7344 4.875H9.75V7.125H13.0781H13.0547ZM2.625 11.25C2.625 11.6719 2.83594 12.0234 3.1875 12.2344C3.51562 12.4453 3.96094 12.4453 4.3125 12.2344C4.64062 12.0234 4.875 11.6719 4.875 11.25C4.875 10.8516 4.64062 10.5 4.3125 10.2891C3.96094 10.0781 3.51562 10.0781 3.1875 10.2891C2.83594 10.5 2.625 10.8516 2.625 11.25ZM11.25 10.125C10.8281 10.125 10.4766 10.3594 10.2656 10.6875C10.0547 11.0391 10.0547 11.4844 10.2656 11.8125C10.4766 12.1641 10.8281 12.375 11.25 12.375C11.6484 12.375 12 12.1641 12.2109 11.8125C12.4219 11.4844 12.4219 11.0391 12.2109 10.6875C12 10.3594 11.6484 10.125 11.25 10.125Z"/>
                        </svg>Ship to:
                        <slot>Malaysia</slot>
                        <svg class="header-country-selector-arrow" width="17" height="17"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            aria-hidden="true" style="margin-left:5px">
                          <polyline points="6 9 12 15 18 9"/>
                        </svg>
                        <!-- <img class="header-country-selector-arrow" src="@/assets/images/arr_white.png" width="17" height="17" style="margin-left: 5px;" alt="" /> -->
                    </span>
                </div>
                
            </div>
        </div>
        <HeaderMenu :cartItem="cartItem" @toggle-minicart="toggleMiniCart" />
        <HeaderMenuMobile :cartItem="cartItem" @toggle-minicart="toggleMiniCart" />
        <MiniCart :isToggle="isToggleMiniCart" @toggle-minicart="toggleMiniCart" />
        <LoadingCny v-if="loading_cny" />
    </header>
    <CountryPopup
        @handleSetCountry="handleSetCountry"
        :showSeclect="showSeclect"
        @closePopup="closePopup"
    />
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
import AnnouncementBar from '@/components/Header/AnnouncementBar.vue';
import MiniCart from '@/components/WooCommerce/MiniCart.vue';
import { scrollHeaderCheck, scrollHeader } from '@/assist/HeaderDesktop';
import { getMiniCart } from '@/assist/MiniCart';
import type { IAPIResponseError } from '~/types/apiResponseError';
import { useRouter, useRoute } from 'vue-router';
import CountryPopup from "@/components/Header/CountryPopup.vue";
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { getLangUrl } from '~/utils/getLangUrl';

// The CNY transition is only needed after an explicit click. Keeping it async
// prevents its scoped CSS and image from blocking the home page render.
const LoadingCny = defineAsyncComponent(() => import('@/components/Home/Loading_cny.vue'));


const router = useRouter()
const route = useRoute()
const runtimeConfig = useRuntimeConfig();
const userStore = useUserStore();
const showSeclect = ref<boolean>(false);
const showPopUp = useCookie("showPopUp");
const loading_cny = ref(false);
const baseUrl = runtimeConfig.public.BASE_URL;

const cartItem = ref<number>(0);
const isToggleMiniCart = ref<boolean>(false);
const item_all_wishlist = ref<[]>;
const hiddenMenu = ref<boolean>(false);
const background_announcement = ref('');
interface IResponse {
    success: boolean;
    data: any[];
};

const toggleMiniCart = () => {
    isToggleMiniCart.value = ! isToggleMiniCart.value;
}

const pageTranslations = usePageTranslations();

// Build query string from route
const buildQueryString = (): string => {
  const query = route.query;
  if (!query || Object.keys(query).length === 0) {
    return '';
  }
  const queryParams = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(v => queryParams.append(key, v));
    } else {
      queryParams.append(key, value as string);
    }
  });
  const queryString = queryParams.toString();
  return queryString ? `?${queryString}` : '';
};

// Compute localized paths with reactivity
const localizedPathEn = computed(() => {
  const trans = pageTranslations.value;
  const path = route.path;
  const queryString = buildQueryString();
  
  // console.log('[computed EN] trans:', trans, 'path:', path);
  
  if (trans?.['en']?.slug) {
    const result = `/${trans['en'].slug}${queryString}`;
    // console.log('[computed EN] returning slug:', result);
    return result;
  }
  const result = (path.replace(/^\/ms-my/, '') || '/') + queryString;
  // console.log('[computed EN] returning fallback:', result);
  return result;
});

const localizedPathMs = computed(() => {
  const trans = pageTranslations.value;
  const path = route.path;
  const queryString = buildQueryString();
  
  // console.log('[computed MS] trans:', trans, 'path:', path);
  
  if (trans?.['ms-my']?.slug) {
    const result = `/ms-my/${trans['ms-my'].slug}${queryString}`;
    // console.log('[computed MS] returning slug:', result);
    return result;
  }
  // Remove trailing slash and /ms-my prefix
  const cleanPath = path.replace(/^\/ms-my/, '').replace(/\/$/, '');
  const result = cleanPath ? `/ms-my${cleanPath}${queryString}` : `/ms-my${queryString}`;
  // console.log('[computed MS] returning fallback:', result);
  return result;
});

// Navigate handler for language links
const navigateToLocalized = (langPath: string) => {
  // console.log('[navigateToLocalized] pushing path:', langPath);
  router.push(langPath);
};

const { $file,$ajax } = useNuxtApp();

interface CampaignData {
  enable: boolean;
  isCny: boolean;
  enable_cny: boolean;
  announcements: {
    text: string;
    link: {
      title: string;
      url: string;
      target: string;
    };
    class: string;
  };
  start: {
    text: string;
    datetime: string;
    button: {
      title: string;
      url: string;
      target: string;
    };
  };
  end: {
    text: string;
    datetime: string;
    button: {
      title: string;
      url: string;
      target: string;
    };
  };
  backgroundAn: string;
}

  try {
    const { data, error } =  await useAsyncData(
      'topbar',
      async () => {
        return $file.get('topbar.json?v=12321312313',
        {
          headers: {
            Authorization: `Bearer ${userStore.csrf}`,
            'X-API-Server': userStore.csrf_server
          }
        });
      }
    );
    const response = data.value as CampaignData;
    
    // Try to find backgroundAn in different places
    if (response?.backgroundAn) {
      background_announcement.value = response.backgroundAn;
    }
  }catch (err: any) {
    console.log('err.response', err);
  }

const currentRoute = router.currentRoute.value.path;

if (currentRoute.includes('/custom-admin/') || currentRoute.includes('/my-account/submission') || currentRoute.includes('/my-account/task')) {
    hiddenMenu.value = true;
}
const shopPopupSelectCountry = () => {
  showSeclect.value = true;
  document.body.style.overflowY = "hidden";
};
const closePopup = (e) => {
  e.stopPropagation();
  showSeclect.value = false;
  document.body.style.overflowY = "auto";
  // console.log('checked')
  setCookie('showPopUp', 'checked', 1);
};

const handleSetCountry = (item: ICurrencyItem) => {
  if (!item) return;
  const countryShort = item.country_short;
  const countryCurrency = item.currency;

  if (countryShort == "AU") {
    window.location.href = "https://www.skjewellery.com/au/";
    return;
  }else if(countryShort == "US"){
    window.location.href = "https://www.skjewellery.com/us/";
    return;
  }else if(countryShort == "SG"){
    window.location.href = "https://www.skjewellery.com/";
    return;
  }else if(countryShort == "MY"){
    return;
  }else{
    window.location.href = "https://www.skjewellery.com/intl/";
    return;
  }

  const country = wooStore.countries[countryShort];
  if (country) {
    const currency = wooStore.currencyList.settings[countryCurrency];
    wooStore.setCountry(country);
    wooStore.setCurrency(currency);

    eventBus.emit("currency:change", {
      country: countryShort,
      currency: countryCurrency,
      rate: currency.rate,
      symbol: currency.symbol,
    });

    // console.log("countryCurrencyxxx", countryCurrency);

    if (countryCurrency === "SGD" && route.path === "/intl/") {
      router.push("/");
    }
    if (
      countryCurrency !== "SGD" &&
      route.path === "/" &&
      route.params &&
      !route.query.s
    ) {
      router.push("/intl/");
    }
  }

  // console.log('handleSetCountry', country);
};

const checkPagePaddingTop = () => {
    const mainEl = document.getElementById('page');
    const mastheadElement = document.getElementById('masthead');
    const cusstomSetElement = document.getElementById('pt-menu-mobile');
    // if( mainEl ) {
    //     if (mastheadElement) {
    //         mainEl.style.top = mastheadElement.clientHeight + 'px';
    //     }
    // }
    const announcementBarEl = document.getElementById('topbar');
    const mbMenu = document.getElementById('alt-header-menu-sp');
    if( window.scrollY > 0) {
        if ( mbMenu && mastheadElement && announcementBarEl ) {
            // mbMenu.style.top = (mastheadElement.clientHeight - announcementBarEl.offsetHeight) + 'px';
            mbMenu.style.top = (mastheadElement.clientHeight - announcementBarEl.offsetHeight - 61) + 'px';
        }
    }else{
        if ( mbMenu && mastheadElement && announcementBarEl ) {
            // mbMenu.style.top = mastheadElement.clientHeight + 'px';
            mbMenu.style.top = (mastheadElement.clientHeight ) + 'px';
        }
    }
}
function generateRandomKey(length = 10) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex];
    }
    return result;
}
const currencyCountry = useCookie("altcs_detect_country");

const openCountryPopupAfterInteraction = () => {
    window.removeEventListener('pointerdown', openCountryPopupAfterInteraction);
    window.removeEventListener('touchstart', openCountryPopupAfterInteraction);
    window.removeEventListener('wheel', openCountryPopupAfterInteraction);
    window.removeEventListener('scroll', openCountryPopupAfterInteraction);
    window.removeEventListener('keydown', openCountryPopupAfterInteraction);

    if (currencyCountry.value !== "MY" && (showPopUp.value === undefined || showPopUp.value !== 'checked')) {
        showSeclect.value = true;
    }
};

const listenForCountryPopupInteraction = () => {
    window.addEventListener('pointerdown', openCountryPopupAfterInteraction, { once: true, passive: true });
    window.addEventListener('touchstart', openCountryPopupAfterInteraction, { once: true, passive: true });
    window.addEventListener('wheel', openCountryPopupAfterInteraction, { once: true, passive: true });
    window.addEventListener('scroll', openCountryPopupAfterInteraction, { once: true, passive: true });
    window.addEventListener('keydown', openCountryPopupAfterInteraction, { once: true });
};

watch(() => locale.value, (newLocale) => {
    getMiniCart();
    setCookie('detect_country', newLocale, 1);
});

onMounted(async() => {
    setCookie('detect_country', locale.value, 1);
    scrollHeader();
    window.addEventListener('scroll', () => {
        scrollHeaderCheck();
    });

    window.addEventListener('touchstart', () => {
        scrollHeaderCheck();
    });

    window.onload = function() {
        scrollHeaderCheck();
    };
    // setPositionCookie();
    setTimeout(function(){
        checkPagePaddingTop();
    }, 1500);
    listenForCountryPopupInteraction();
    if (!getCookie("share_key_wishlist") && !userStore.isLogin) {
        setCookie('share_key_wishlist', generateRandomKey(), 1);
    }
    if(!localStorage.getItem('list_wishlist')){
        localStorage.setItem('list_wishlist', JSON.stringify([]));
    }
    if (!localStorage.getItem('all_item_wishlist') && userStore.isLogin) {
        localStorage.setItem('all_item_wishlist', JSON.stringify([]));
        try {
            const response = await $ajax.get<IResponse>(`wp-json/skj/v1/wishlist/list?sharekey=${userStore.user.wishlist_sharekey}`,{ headers: {"Authorization": `Bearer ${userStore.csrf}`,'X-API-Server': userStore.csrf_server} });
            if(response.success){
                item_all_wishlist.value = response.data;
                const convertedValues = item_all_wishlist.value.map(item => Number(item));
                localStorage.setItem('all_item_wishlist', JSON.stringify(convertedValues));
            }
        } catch (error) {
            if (error && typeof error === 'object' && 'data' in error) {
                const errorData = error.data as IAPIResponseError;
                //console.log('getWhislistErrorCatch', errorData.code);
            } else {
                //console.log('Unexpected error:', error);
            }
        }
    }

    // setScroll();

})

onBeforeUnmount(() => {
    window.removeEventListener('pointerdown', openCountryPopupAfterInteraction);
    window.removeEventListener('touchstart', openCountryPopupAfterInteraction);
    window.removeEventListener('wheel', openCountryPopupAfterInteraction);
    window.removeEventListener('scroll', openCountryPopupAfterInteraction);
    window.removeEventListener('keydown', openCountryPopupAfterInteraction);
});

</script>
